import config from '../../../config';
import {authFetch, checkStatus} from '../../utils/http';
import {getURIEncodedTimeZone} from '../../utils/datetime';

export default class LiveSignatureService {
  signDocument(documentId) {
    return authFetch(`${config.signatureApi}/api/v1/signature/sign/${documentId}?timeZone=${getURIEncodedTimeZone()}`, {
      method: 'POST'
    })
      .then(checkStatus)
      .then(response => response.json());
  }

  sendSignedDocument(transactionId) {
    return authFetch(`${config.signatureApi}/api/v1/signature/callback/${transactionId}`)
      .then(checkStatus)
      .then(response => (response.status === 204 ? null : response.json()));
  }
}
